import React from "react";
import styled from "styled-components";

import { translations } from "../../../utils/translations.js";
import { useSelector } from "react-redux";

const Wrapper = styled.div`
  height: 100%;
  width: 75%;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  flex-direction: column;
  @media (max-width: 768px) {
    overflow-x: auto; /* Permite derularea pe orizontală */

    padding: 1rem;
  }
`;

const PageTitle = styled.h2`
  color: var(--secondary-font-color);
  text-align: center;
  font-family: Georgia, serif;
  width: 75%;
`;

const SubTitle = styled.h3`
  color: var(--secondary-font-color);
  font-family: Georgia, serif;
  width: 100%;
`;

const Text = styled.p`
  color: var(--secondary-font-color);
  text-align: justify;
  font-family: Verdana, sans-serif;
  width: 90%;
  @media (max-width: 768px) {
    width: 100%; /* Pe mobil, ocupă întreaga lățime */
  }
`;

const List = styled.ul`
  color: var(--secondary-font-color);
  font-family: Verdana, sans-serif;
  width: 90%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const TextSection = styled.div`
  color: var(--secondary-font-color);
  font-family: Verdana, sans-serif;
  width: 90%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const ReturPage = () => {
  const languageCode = useSelector((state) => state.settings.languageCode);
  if (languageCode === "ro")
    return (
      <Wrapper>
        <PageTitle>
          {translations[languageCode]["footer-retur-section"]}
        </PageTitle>

        <TextSection>
          <SubTitle>Politica de retur pentru produse fizice</SubTitle>
          <Text>
            Majoritatea produsele noastre nu sunt păstrate în stoc, ci sunt
            printate 3D la momentul plasării comenzii. Prin urmare, returnarea
            sau înlocuirea unui produs custom comandat este posibilă doar dacă
            acesta ajunge deteriorat, cu defect sau inutilizabil. În astfel de
            cazuri, produsul beneficiază de garanție și poate fi înlocuit la
            cerere sau se poate restitui suma achitată. Produsele standard
            comandate de pe site au drept de retur în termen de 14 zile de la
            primirea comenzii, conform legislației în vigoare.
          </Text>
          <Text>
            Vă rugăm să rețineți că produsele nu pot fi înlocuite sau returnate
            dacă au fost deteriorate de către client. La livrarea comenzii,
            clientul are obligația de a inspecta produsul și de a raporta orice
            problemă în termen de maximum 24 de ore. Reclamațiile ulterioare nu
            vor fi luate în considerare.
          </Text>
          <Text>
            Pentru orice produs returnat sau înlocuit, costurile de transport
            sunt suportate de client. În cazul în care produsul este defect,
            costurile de transport vor fi suportate de către noi.
          </Text>
          <Text>
            În cazul unui retur pentru un produs custom, costul proiectului 3D
            nu se va returna.
          </Text>

          <Text>
            Observații importante:
            <List>
              <li>
                Aspectul liniar al straturilor, caracteristic tehnologiei de
                tipărire 3D utilizate, nu se consideră defect.
              </li>
              <li>
                Aspectul natural al lichenilor nu este considerat un defect.
                Culorile pot fi neuniforme, iar lichenii pot prezenta
                imperfectiuni la suprafață, specifice acestui tip de plante.
              </li>
            </List>
          </Text>
        </TextSection>

        <TextSection>
          <SubTitle>Politica de retur pentru produse digitale</SubTitle>
          <Text>
            Produsele digitale precum fișiere STL, GCODE sau proiectele 3D
            custom, nu pot fi returnate sau înlocuite. Clientul are obligația de
            a verifica compatibilitatea fișierelor cu echipamentul său înainte
            de a plasa comanda, sau în cazul proiectelor 3D, de a verifica
            specificațiile și cerințele proiectului și de a comunica eventualele
            probleme cu designerul în timpul procesului de proiectare.
          </Text>
        </TextSection>

        <TextSection>
          <SubTitle> Procedura de retur</SubTitle>
          <Text>
            Pentru a beneficia de retur vă rugam să ne contactați la adresa de
            email sau telefonic. Pentru a determina eligibilitatea returului, vă
            rugăm să ne furnizați următoarele informații:
            <List>
              <li>Nume și prenume</li>
              <li>Număr de telefon</li>
              <li>Motivul returului</li>
              <li>Fotografii cu produsul deteriorat</li>
            </List>
          </Text>
        </TextSection>
      </Wrapper>
    );
  else
    return (
      <Wrapper>
        <PageTitle>
          {translations[languageCode]["footer-retur-section"]}
        </PageTitle>

        <TextSection>
          <SubTitle>Return Policy for Physical Products</SubTitle>
          <Text>
            Most of our products are not kept in stock, but are 3D printed at
            the time of placing the order. Therefore, returns or exchanges for
            custom products can only be accepted if the product arrives damaged,
            with defects, or unusable. In such cases, the product is covered by
            a warranty and can be replaced upon request or the amount paid can
            be refunded. Standard products ordered from the website have a
            return policy within 14 days of receiving the order, in accordance
            with current legislation.
          </Text>
          <Text>
            Please note that products cannot be exchanged or returned if they
            have been damaged by the customer. Upon delivery, the customer is
            required to inspect the product and report any issues within 24
            hours. Complaints made after this period will not be considered.
          </Text>
          <Text>
            For any returned or exchanged product, the shipping costs are to be
            borne by the customer. If the product is defective, the shipping
            costs will be covered by us.
          </Text>
          <Text>
            In the case of a return for a custom product, the cost of the 3D
            design will not be refunded.
          </Text>

          <Text>
            Important Notes:
            <List>
              <li>
                The linear appearance of the layers, characteristic of the 3D
                printing technology used, is not considered a defect.
              </li>
              <li>
                The natural appearance of the moss is not considered a defect.
                The colors may be uneven, and the moss may show surface
                imperfections typical of this type of plant.
              </li>
            </List>
          </Text>
        </TextSection>

        <TextSection>
          <SubTitle>Return Policy for Digital Products</SubTitle>
          <Text>
            Digital products such as STL files, GCODE, or custom 3D designs
            cannot be returned or exchanged. The customer is responsible for
            checking the compatibility of the files with their equipment before
            placing the order, or in the case of 3D projects, for reviewing the
            project specifications and requirements and communicating any issues
            with the designer during the design process.
          </Text>
        </TextSection>

        <TextSection>
          <SubTitle>Return Procedure</SubTitle>
          <Text>
            To benefit from a return, please contact us by email or phone. To
            determine the eligibility of the return, please provide us with the
            following information:
            <List>
              <li>Full name</li>
              <li>Phone number</li>
              <li>Reason for return</li>
              <li>Photos of the damaged product</li>
            </List>
          </Text>
        </TextSection>
      </Wrapper>
    );
};

export default ReturPage;
